import React, { useState } from 'react';
import './CalculatorPage.css';

function MarriageCompatibilityCalculator() {
  const [dob1, setDob1] = useState('');
  const [dob2, setDob2] = useState('');
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const calculateLifePath = (dateString) => {
    const digitsOnly = dateString.replace(/\D/g, '');
    if (digitsOnly.length !== 8) return null;

    const day = parseInt(digitsOnly.substring(0, 2), 10);
    const month = parseInt(digitsOnly.substring(2, 4), 10);
    const year = parseInt(digitsOnly.substring(4, 8), 10);

    if (month < 1 || month > 12 || day < 1 || day > 31 || year < 1900 || year > 2100) {
      return null;
    }

    let sum = 0;
    for (let i = 0; i < digitsOnly.length; i++) {
      sum += parseInt(digitsOnly[i], 10);
    }

    while (sum > 9 && sum !== 11 && sum !== 22 && sum !== 33) {
      sum = sum.toString().split('').reduce((s, d) => s + parseInt(d, 10), 0);
    }
    return sum;
  };

  const calculateCompatibility = (lp1, lp2) => {
    // Placeholder for Marriage Compatibility calculation logic
    // This is a simplified example; real numerology compatibility is complex.
    if (lp1 === null || lp2 === null) return null;

    if (lp1 === lp2) {
      return "Excellent Compatibility";
    } else if (Math.abs(lp1 - lp2) <= 2) {
      return "Good Compatibility";
    } else {
      return "Moderate Compatibility";
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');
    setResult(null);

    const dateRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!dateRegex.test(dob1) || !dateRegex.test(dob2)) {
      setError('Please enter valid dates in DD/MM/YYYY format for both individuals.');
      return;
    }

    const lp1 = calculateLifePath(dob1);
    const lp2 = calculateLifePath(dob2);

    if (lp1 === null || lp2 === null) {
      setError('Invalid date input. Please check both dates.');
    } else {
      setResult(calculateCompatibility(lp1, lp2));
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Marriage Compatibility Calculator",
    "description": "Check marriage compatibility based on numerology and birth dates.",
    "url": "https://www.yourwebsite.com/marriage-compatibility-calculator",
    "potentialAction": {
      "@type": "CalculateAction",
      "name": "Calculate Marriage Compatibility",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://www.yourwebsite.com/marriage-compatibility-calculator?dob1={dob1}&dob2={dob2}",
        "actionPlatform": [
          "http://schema.org/DesktopWebPlatform",
          "http://schema.org/MobileWebPlatform"
        ]
      },
      "query-input": [
        "required name=dob1",
        "required name=dob2"
      ]
    }
  };

  return (
    <div className="calculator-page container my-8">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
      />
      <h1 className="text-center text-primary">Marriage Compatibility Calculator</h1>
      <p className="text-center">Enter birth dates of two individuals to check their numerological compatibility.</p>

      <form onSubmit={handleSubmit} className="calculator-form shadow-md rounded-lg p-6">
        <div className="form-group">
          <label htmlFor="dob1">Date of Birth (Individual 1 - DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob1"
            className="form-control"
            value={dob1}
            onChange={(e) => setDob1(e.target.value)}
            placeholder="e.g., 01/01/1990"
            maxLength="10"
          />
        </div>
        <div className="form-group">
          <label htmlFor="dob2">Date of Birth (Individual 2 - DD/MM/YYYY):</label>
          <input
            type="text"
            id="dob2"
            className="form-control"
            value={dob2}
            onChange={(e) => setDob2(e.target.value)}
            placeholder="e.g., 15/05/1992"
            maxLength="10"
          />
        </div>
        {error && <p className="error-message">{error}</p>}
        <button type="submit" className="btn btn-primary">Check Compatibility</button>
      </form>

      {result !== null && (
        <div className="result-section text-center my-8 p-6 shadow-md rounded-lg">
          <h2>Compatibility Result: <span className="result-number">{result}</span></h2>
          <p className="result-explanation">This is a placeholder explanation for the marriage compatibility result.</p>
        </div>
      )}
    </div>
  );
}

export default MarriageCompatibilityCalculator;
